module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/201707/top_images/2-73a76bece7ed89f73fd84ebce72b029d.png";